import React from "react";

export default function Toast({ message, type = "ok" }) {
  const isError = type === "err";
  return (
    <div
      className={`toast ${isError ? "err" : ""}`}
      role="status"
      data-testid="toast"
    >
      {message}
    </div>
  );
}
